<div class="container-fluid d-flex flex-column h-100 pb-3">
  <div class="row align-items-center mb-3">
    <div class="col-8">
      <h2>Admin - API Keys</h2>
    </div>
    <div class="col-4 text-end">
      <button
        type="button"
        class="btn btn-primary"
        (click)="generateKey()"
        [disabled]="isCreating"
      >
        {{ isCreating ? 'GENERATING...' : 'Generate API key' }}
      </button>
    </div>
  </div>

  <div class="row flex-grow-1">
    <div class="col">
      @if (isLoading) {
        <div class="text-center py-4">Loading...</div>
      } @else if (apiKeys.length === 0) {
        <div class="text-center py-4 text-muted">
          No API keys found. Click <strong>Generate API key</strong> to create
          one.
        </div>
      } @else {
        <table class="table table-bordered table-hover mt-2">
          <thead class="table-primary">
            <tr>
              <th>API Key</th>
              <th>Created</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            @for (key of apiKeys; track key.id) {
              <tr [class.newly-created-row]="key.id === newlyCreatedKeyId">
                <td class="font-monospace">
                  {{ key.apiAccessKey }}
                  @if (key.id === newlyCreatedKeyId) {
                    <span class="copy-warning ms-2">
                      <i class="bi bi-exclamation-triangle-fill me-1"></i>Copy
                      now — won't be shown again
                    </span>
                  }
                </td>
                <td>{{ key.createdAt | date: 'MM/dd/yyyy hh:mm a' }}</td>
                <td class="actions-cell">
                  @if (key.id === newlyCreatedKeyId) {
                    <i
                      class="bi bi-clipboard-fill action-icon copy-icon me-2"
                      (click)="copyKey(key)"
                      title="Copy API key"
                    ></i>
                    <i
                      class="bi bi-x-circle-fill action-icon dismiss-icon me-2"
                      (click)="dismissNewKey()"
                      title="Dismiss"
                    ></i>
                  }
                  <i
                    class="bi bi-trash-fill action-icon delete-icon"
                    (click)="confirmDelete(key)"
                    title="Delete"
                  ></i>
                </td>
              </tr>
            }
          </tbody>
        </table>
      }
    </div>
  </div>
</div>
